import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ReceiptService } from 'app/services/receipt-service';
import { ReceiptParamDTO } from 'app/header-footer-template/model/ReceiptParamDTO';
import { ToastrService } from 'ngx-toastr';
import { CommonsText } from 'app/commons/CommonsText';
var ProfileReceiptsComponent = /** @class */ (function () {
    function ProfileReceiptsComponent(receiptService, toastr, router) {
        this.receiptService = receiptService;
        this.toastr = toastr;
        this.router = router;
        this.filtersOpen = true;
        this.loading = false;
        this.filters = {
            product: '',
            statusType: '',
            policyNumber: '',
            policyCollective: '',
            startDate: '',
            endDate: ''
        };
        this.productList = [];
        this.statusTypeList = [];
        this.params = new ReceiptParamDTO();
    }
    ProfileReceiptsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.params.pageOffset = 0;
        this.params.pageSize = 10;
        this.search();
        this.receiptService.observerPageSizeChange().subscribe(function (result) {
            _this.params.pageOffset = 0;
            _this.params.pageSize = result;
            window.scrollTo(0, 0);
            _this.search();
        });
        this.receiptService.observerPageOffset().subscribe(function (result) {
            _this.params.pageOffset = result;
            window.scrollTo(0, 0);
            _this.search();
        });
        this.receiptService.observerPageFilter().subscribe(function (result) {
            _this.params.startDate = result.startDate;
            _this.params.endDate = result.endDate;
            _this.params.statusType = result.statusType;
            _this.params.policyNumber = result.policyNumber;
            _this.params.product = result.product;
            _this.params.policyCollective = result.policyCollective;
            _this.params.policyItems = [];
            _this.search();
        });
    };
    ProfileReceiptsComponent.prototype.search = function () {
        var _this = this;
        this.loading = true;
        this.receiptService.search(this.params)
            .then(function (success) {
            _this.loading = false;
            _this.response = success;
            if (success) {
                _this.productList = success.product || [];
                _this.statusTypeList = success.statusType || [];
                if (success.content) {
                    success.content.forEach(function (item) {
                        item.payActions = _this.buildPayActions(item);
                    });
                }
            }
        })
            .catch(function () {
            _this.loading = false;
            _this.response = null;
            _this.toastr.error(CommonsText.PROBLEMA_SERVICIO_RECIBOS, CommonsText.PROBLEMA_DE_CONECTIVIDAD, {
                timeOut: 5000
            });
        });
    };
    ProfileReceiptsComponent.prototype.toggleFilters = function () {
        this.filtersOpen = !this.filtersOpen;
    };
    ProfileReceiptsComponent.prototype.applyFilters = function () {
        this.receiptService.setPageFilter({
            startDate: this.filters.startDate,
            endDate: this.filters.endDate,
            statusType: this.filters.statusType ? [{ id: this.filters.statusType }] : [],
            policyNumber: this.filters.policyNumber,
            product: this.filters.product ? [{ id: this.filters.product }] : [],
            policyCollective: this.filters.policyCollective,
            policyItems: []
        });
    };
    ProfileReceiptsComponent.prototype.pay = function (data) {
        this.receiptService.payment(data);
    };
    ProfileReceiptsComponent.prototype.buildPayActions = function (item) {
        var _this = this;
        return [
            {
                label: 'Tarjeta',
                icon: 'card',
                action: function () { return _this.pay(item); }
            },
            {
                label: 'Cuenta bancaria',
                icon: 'bank',
                action: function () { return _this.router.navigate(['/receipt', 'nw', item.receiptNumber]); }
            }
        ];
    };
    ProfileReceiptsComponent.prototype.download = function (data) {
        // TODO: wire to PDF download endpoint when available
    };
    ProfileReceiptsComponent.prototype.isPending = function (item) {
        return item.receiptStatusColor === 'red';
    };
    Object.defineProperty(ProfileReceiptsComponent.prototype, "currentPage", {
        get: function () {
            return this.response ? this.response.number + 1 : 1;
        },
        enumerable: true,
        configurable: true
    });
    ProfileReceiptsComponent.prototype.getPages = function () {
        if (!this.response || !this.response.totalPages) {
            return [];
        }
        var total = this.response.totalPages;
        var current = this.currentPage;
        if (total <= 7) {
            return Array.from({ length: total }, function (_, i) { return i + 1; });
        }
        var start = Math.max(1, current - 2);
        var end = Math.min(total, current + 2);
        if (end - start < 4) {
            if (start === 1) {
                end = Math.min(total, 5);
            }
            else {
                start = Math.max(1, end - 4);
            }
        }
        var pages = [];
        if (start > 1) {
            pages.push(1);
            if (start > 2) {
                pages.push(null);
            }
        }
        for (var i = start; i <= end; i++) {
            pages.push(i);
        }
        if (end < total) {
            if (end < total - 1) {
                pages.push(null);
            }
            pages.push(total);
        }
        return pages;
    };
    ProfileReceiptsComponent.prototype.prev = function () {
        if (!this.loading && this.response && !this.response.first) {
            this.receiptService.setPageOffset(this.response.number - 1);
        }
    };
    ProfileReceiptsComponent.prototype.next = function () {
        if (!this.loading && this.response && !this.response.last) {
            this.receiptService.setPageOffset(this.response.number + 1);
        }
    };
    ProfileReceiptsComponent.prototype.goToPage = function (p) {
        if (!this.loading) {
            this.receiptService.setPageOffset(p - 1);
        }
    };
    return ProfileReceiptsComponent;
}());
export { ProfileReceiptsComponent };
